import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Label,
} from "reactstrap";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import Spinners from "components/Common/Spinner";
import * as url from "../../helpers/url_helper";
import { MDBDataTable } from "mdbreact";
import { Modal, Button } from "react-bootstrap";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import { Link, useLocation } from "react-router-dom";

const SangathanMemberList = (props) => {
  const [isLoading, setLoading] = useState(false);
  const [sangathanMemberList, setSangathanMemberList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [sangathanList, setSangathanList] = useState([]);
  const [sangathanName, setSangathanName] = useState("");
  const [sangathanCount, setSangathanCountList] = useState("");
  const [totalUserCount, setSubSangathan] = useState(0);
  const [sangathanUserCount, setSangathanUserCount] = useState(0);

  const location = useLocation();
  const hierarchy = location.state?.hierarchy || [];
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Sangathan Member List", link: "#" },
  ];
  useEffect(() => {
    onGetSangathanList();
    // setDefaultFilter(!!(startDate && endDate));
    props.setBreadcrumbItems("Sangathan Member List", breadcrumbItems);
  }, []);

  function onGetSangathanList() {
    setLoading(true);

    const urlPath = `/sangathan/sangathanlist`;
    fetch(url.beta_url + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          setSangathanList(responseData.result.sangathanList);
          setSangathanCountList(responseData.result.sangathanCount);
          setSubSangathan(responseData.result.grandTotal);
          setSangathanUserCount(responseData.result.totalSubSangathanCount);
        } else {
          console.error("API Error:", responseData.error || "Unknown error");
        }
      })
      .catch((error) => {
        console.log("err", error);
      })
      .finally((final) => {
        setLoading(false);
      });
  }

  function exportToExcel(data) {
    var fileName = "SangathanMemberList";
    const flatData = (data || []).map((item) => {
      const user = item.userId || {};
      return {
        FullName: `${user.firstName || ""} ${user.lastName || ""}`,
        VUF_ID: user.vufId || "",
        Mobile: user.mobileNo || "",
        RoleSangathan: item.role || "",
      };
    });
    const worksheet = XLSX.utils.json_to_sheet(flatData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  }
  const formattedList = sangathanList.map((data) => ({
    ...data,
    sangathanCount: sangathanCount,
    totalCount: totalUserCount,
    sangathanName: [
      <Link
        to={`/parent-sangathans-list/${data._id}`}
        state={{
          hierarchy: [...(data.name || []), { id: data._id, name: data.name }],
        }}
      >
        {data.name}({sangathanUserCount})
      </Link>,
    ],
    Action: [
      <>
        <Link
          to={`/sangathan/view-member-list/${data._id}/sangathan`}
          className="btn btn-outline-primary me-2"
        >
          Sangathan User <i className="fa fa-eye"></i>
        </Link>
        <Link
          to={`/sangathan/view-member-list/${data._id}/subsangathan`}
          className="btn btn-outline-secondary"
        >
          Sub Sangathan All Users <i className="fa fa-eye"></i>
        </Link>
      </>,
    ],
  }));
  const totalUsersSum = formattedList.reduce(
    (acc, curr) => acc + Number(curr.totalCount || 0),
    0,
  );
  const sangathanUsersSum = formattedList.reduce(
    (acc, curr) => acc + Number(curr.sangathanCount || 0),
    0,
  );
  const footerRow = {
    sangathanName: <strong>Total</strong>,
    totalCount: <strong>{totalUsersSum}</strong>,
    sangathanCount: <strong>{sangathanUsersSum}</strong>,
    Action: "", // Empty for the action column
  };
  const tableData = {
    columns: [
      {
        label: "Sangathan Name",
        field: "sangathanName",
        width: 23,
      },
      {
        label: "Sangathan User",
        width: 13,
        field: "sangathanCount",
      },
      {
        label: "Total Sangathan Users",
        width: 13,
        field: "totalCount",
      },
      {
        label: "Action",
        width: 13,
        field: "Action",
      },
    ],
    rows: [...formattedList, footerRow],
  };
  const formattedMemberList = sangathanMemberList.map((data) => ({
    ...data.userId,
    fullName: `${data.userId.firstName} ${data.userId.lastName}`,
  }));
  const tableMemberData = {
    columns: [
      {
        label: "Full Name",
        field: "fullName",
        width: 23,
      },
      {
        label: "Mobile No.",
        width: 13,
        field: "mobileNo",
      },
      {
        label: "VUFID",
        width: 13,
        field: "vufId",
      },
    ],
    rows: formattedMemberList,
  };
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="12">
                    <CardTitle className="h4 mb-0">Sangathan List</CardTitle>
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/sangathan-member-list">Home</Link>
                        </li>
                        {hierarchy.map((item, i) => {
                          const isLast = i === hierarchy.length - 1;
                          return (
                            <li
                              key={item.id}
                              className={`breadcrumb-item ${isLast ? "active" : ""}`}
                              aria-current={isLast ? "page" : undefined}
                            >
                              {isLast ? (
                                item.name
                              ) : (
                                <Link
                                  to={`/parent-sangathans-list/${item.id}`}
                                  state={{
                                    hierarchy: hierarchy.slice(0, i + 1),
                                  }}
                                >
                                  {item.name}
                                </Link>
                              )}
                            </li>
                          );
                        })}
                      </ol>
                    </nav>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div class="row">
                  <MDBDataTable
                    responsive
                    striped
                    bordered
                    data={tableData}
                    noBottomColumns={true}
                    entries={20}
                  />
                </div>
                <div className="row">
                  <Modal
                    size="xl"
                    centered
                    show={showModal}
                    backdrop="static"
                    keyboard={false}
                    onHide={() => setShowModal(false)}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Member List of {sangathanName}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="row">
                        <div className="d-flex justify-content-end">
                          {sangathanMemberList.length > 0 && (
                            <Button
                              onClick={(event) =>
                                exportToExcel(sangathanMemberList)
                              }
                            >
                              Export Data
                            </Button>
                          )}
                        </div>
                        <MDBDataTable
                          responsive
                          striped
                          bordered
                          data={tableMemberData}
                        />
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => setShowModal(false)}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(SangathanMemberList);
